import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  products: drilldownData["products"].map(({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType,imageDimension }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    options: options,
    loadOptions: loadOptions,
    usedFileType: usedFileType,
    imageDimension: imageDimension
  })),
  productBrand: drilldownData["productBrand"].map(({ fieldName, placeholder, name, formType, validation, className, loadOptions, usedFileType, imageDimension }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    loadOptions: loadOptions,
    usedFileType: usedFileType,
    imageDimension: imageDimension
  })),
  subCategories: drilldownData["subCategories"].map(({ fieldName, placeholder, name, formType, validation, className, loadOptions, usedFileType }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    loadOptions: loadOptions,
    usedFileType: usedFileType
  })),
  categories: drilldownData["categories"].map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, imageDimension }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    imageDimension: imageDimension
  })),
  fAndBContent: drilldownData["fAndBContent"].map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, imageDimension }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    imageDimension: imageDimension
})),
fAndBBrands: drilldownData["fAndBBrands"].map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, imageDimension }: ModuleFields) => ({
  name: name,
  type: formType,
  label: fieldName,
  placeholder: placeholder,
  validation: validation,
  className: className,
  usedFileType: usedFileType,
  imageDimension: imageDimension
})),
fAndBOutlet: drilldownData["fAndBOutlet"].map(({ fieldName, placeholder, name, formType, validation, className, loadOptions, usedFileType, imageDimension }: ModuleFields) => ({
  name: name,
  type: formType,
  label: fieldName,
  placeholder: placeholder,
  validation: validation,
  className: className,
  loadOptions: loadOptions,
  usedFileType: usedFileType,
  imageDimension: imageDimension
})),
fAndBCategory: drilldownData["fAndBCategory"].map(({ fieldName, placeholder, name, formType, validation, className, loadOptions, usedFileType, imageDimension }: ModuleFields) => ({
  name: name,
  type: formType,
  label: fieldName,
  placeholder: placeholder,
  validation: validation,
  className: className,
  loadOptions: loadOptions,
  usedFileType: usedFileType,
  imageDimension: imageDimension
})),
  eXpress: drilldownData["eXpress"].map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, imageDimension }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    imageDimension: imageDimension
  })),
};
